import { render } from "./ThemeV2Info.vue?vue&type=template&id=05b17dde&scoped=true"
import script from "./ThemeV2Info.vue?vue&type=script&lang=js"
export * from "./ThemeV2Info.vue?vue&type=script&lang=js"

import "./ThemeV2Info.vue?vue&type=style&index=0&id=05b17dde&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b17dde"]])

export default __exports__